import { z } from 'zod';

export const ApiErrorSchema = z.object({
  name: z.string(),
  message: z.string(),
});

export type ApiErrorResponse = z.infer<typeof ApiErrorSchema>;
